import {IStorage} from "./storage.interface";
import {NullableString} from "../../types/nullable-types";

export class InMemoryStorage implements IStorage {
    private _storage: Record<string, NullableString> = {};
    getItem(key: string): string | null {
        return this._storage[key] || null;
    }

    removeItem(key: string): void {
        delete this._storage[key];
    }

    setItem(key: string, value: string): void {
        this._storage[key] = value;
    }

}
